export const THEMES = {
  LIGHT: "light",
  DARK: "dark",
};
export const isDark = (theme) => theme.palette.mode === "dark";

// FOR LAYOUT 2 SECONDARY SIDEBAR
export const secondarySideBarGap = 80;
export const secondarySideBarWidth = 215;

export const RarityColors = {
  C: "#9AAFC5",
  UR: "#DEA54D",
  SR: "#A54DDD",
  UL: "#DC4D55",
  R: "#6860FF",
};
export const RarityFrames = {
  C: "/images-asset/frame-C.png",
  UR: "/images-asset/frame-UR.png",
  SR: "/images-asset/frame-SR.png",
  UL: "/images-asset/frame-UL.png",
  R: "/images-asset/frame-R.png",
};
export const canvasScale = 8
export const BulletColors = [
  '255,255,255',
  '255, 255, 115',
  '138, 255, 143',
  '255, 146, 143',
  '110, 206, 222',
  '96, 229, 211',
  '227, 164, 246'
]
export const Rarity = {
  Godlike: { title: 'Godlike', gradient: 'linear-gradient(#3DFDF7,#D0FA69)', color: '#3DFDF7', dailyEarn: 96000 * 24, star: 7, starText: 'Seven' },
  Supreme: { title: 'Supreme', gradient: 'linear-gradient(#ED3BF7,#F68769)', color: '#ED3BF7', dailyEarn: 10000 * 24, star: 6, starText: 'Six', nextRarity: 'Godlike' },
  Eternal: { title: 'Eternal', color: '#E33739', dailyEarn: 960 * 24, star: 5, starText: 'Five', nextRarity: 'Supreme' },
  Divine: { title: 'Divine', color: '#8347D9', dailyEarn: 72 * 24, star: 4, starText: 'Four', nextRarity: 'Eternal' },
  Mythic: { title: 'Mythic', color: '#FFF380', dailyEarn: 10.8 * 24, star: 3, starText: 'Three', nextRarity: 'Divine' },
  Rare: { title: 'Rare', color: '#44D7C6', dailyEarn: 0.88 * 24, star: 2, starText: 'Two', nextRarity: 'Mythic' },
  Uncommon: { title: 'Uncommon', color: '#4485D7', dailyEarn: 0.75 * 24, star: 1, starText: 'One', nextRarity: 'Rare' },
  Common: { title: 'Common', color: '#AFAFAF', dailyEarn: 0.08 * 24, star: 0, starText: 'None', nextRarity: 'Uncommon' },
}
export const Version = '1.0.9'
